import type { ReactNode } from 'react'
import { cx } from '../../cx'
import styles from './EmptyState.module.css'

/*
 * Pusty stan wg wzorca makiet („Brak osób dla tego filtra…") — zamiast danych
 * demo pokazujemy tytuł, opis i ewentualne CTA [D19].
 */

export interface EmptyStateProps {
  icon?: ReactNode
  title: ReactNode
  description?: ReactNode
  cta?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, cta, className }: EmptyStateProps) {
  return (
    <div className={cx(styles.root, className)}>
      {icon !== undefined ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <h3 className={styles.title}>{title}</h3>
      {description !== undefined ? <p className={styles.description}>{description}</p> : null}
      {cta !== undefined ? <div className={styles.cta}>{cta}</div> : null}
    </div>
  )
}
